import { type FC, type ReactNode } from "react";

import styled from "@emotion/styled";
import { Button, Colors } from "@snapchat/snap-design-system";

interface ButtonLinkProps {
    onClick: () => void;
    fontSize?: number;
    className?: string;
    children?: ReactNode;
}

const ButtonLinkWrapper = styled.span<{ fontSize?: number }>`
    > .sds-base-button.ant-btn.link {
        cursor: pointer;

        min-height: 12px;
        margin: 0;
        padding: 0;

        font-size: ${({ fontSize }) => fontSize ?? 12}px;
        font-weight: 400;
        color: ${Colors.Blue.V100};
    }
`;

export const ButtonLink: FC<ButtonLinkProps> = ({ onClick, fontSize, children, className }) => (
    <ButtonLinkWrapper fontSize={fontSize} className={className}>
        <Button type="link" onClick={onClick}>
            {children}
        </Button>
    </ButtonLinkWrapper>
);
